<template>
  <div class="edit-motivo-rechazo">
    <h1>Editar Motivo de Rechazo</h1>
    
    <div class="alert alert-info" v-if="loading">Cargando motivo de rechazo...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <form @submit.prevent="submitForm" v-if="!loading && !error">
      <div class="mb-3">
        <label for="idMotivoRechazo" class="form-label">ID</label>
        <input 
          type="number" 
          class="form-control" 
          id="idMotivoRechazo" 
          v-model.number="motivoRechazo.IdMotivoRechazo" 
          disabled
        >
      </div>
      <div class="mb-3">
        <label for="descripcion" class="form-label">Descripciu00f3n</label>
        <textarea 
          class="form-control" 
          id="descripcion" 
          rows="3" 
          v-model="motivoRechazo.Descripcion"
          required
        ></textarea>
      </div>
      <div class="d-flex gap-2">
        <button type="submit" class="btn btn-primary" :disabled="saving">
          {{ saving ? 'Guardando...' : 'Guardar Cambios' }}
        </button>
        <button type="button" class="btn btn-secondary" @click="goBack">
          Cancelar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import EditMotivoRechazoViewController from '../controllers/EditMotivoRechazoViewController';

export default {
  name: 'EditMotivoRechazoView',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new EditMotivoRechazoViewController()
    };
  },
  computed: {
    motivoRechazo() {
      return this.controller.motivoRechazo;
    },
    loading() {
      return this.controller.loading;
    },
    saving() {
      return this.controller.saving;
    },
    error() {
      return this.controller.error;
    }
  },
  created() {
    const id = this.$route.params.id;
    this.controller.initialize(id);
  },
  methods: {
    async submitForm() {
      const result = await this.controller.saveMotivoRechazo();
      
      if (result.success) {
        this.$mgkResponse.handleResponse(result.response).then(() => {
          this.$router.push('/motivos-rechazo');
        });
      } else {
        this.error = result.message;
      }
    },
    
    updateField(field, value) {
      this.controller.updateField(field, value);
    },
    
    goBack() {
      this.$router.push('/motivos-rechazo');
    }
  }
}
</script>

<style scoped>
.edit-motivo-rechazo {
  padding: 20px;
}
</style>
